<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  currentPage: { type: Number, required: true },
  totalPages: { type: Number, required: true },
  totalCount: { type: Number, default: 0 },
});

const emit = defineEmits(['change']);
const { t } = useI18n();
</script>

<template>
  <div class="flex flex-wrap items-center justify-between gap-3 mt-5">
    <p class="mb-0 text-sm text-n-slate-11">
      {{
        t('AI_REVIEWS.PAGINATION.SUMMARY', {
          currentPage,
          totalPages,
          totalCount,
        })
      }}
    </p>
    <div class="flex items-center gap-2">
      <Button
        :label="t('AI_REVIEWS.PAGINATION.PREVIOUS')"
        icon="i-lucide-chevron-left"
        color="slate"
        variant="faded"
        size="sm"
        :disabled="currentPage <= 1"
        @click="emit('change', currentPage - 1)"
      />
      <Button
        :label="t('AI_REVIEWS.PAGINATION.NEXT')"
        icon="i-lucide-chevron-right"
        trailing-icon
        color="slate"
        variant="faded"
        size="sm"
        :disabled="currentPage >= totalPages"
        @click="emit('change', currentPage + 1)"
      />
    </div>
  </div>
</template>
